<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="center1"><span class="big">The Call<br/>of the Desert</span></p>
<p class="center"><span class="big2">Abby Green</span><br/><br/><br/><br/><br/></p>
<p class="center"><img alt="" src="OEBPS/images/logo.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781460346396_epub_tp_r1.vue?36f097a6